import styled from 'styled-components'
export interface ContainerProps {
  flexDirection?: string
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection || 'row'};
  width: 100%;
  overflow: hidden;
`
export const SideContainer = styled.div`
  background-color: #e5e5e5;
  height: 100%;
  width: 100%;
  padding: 50px 0 84px 0;

  &.tasks {
    width: 75%;

    @media (max-width: 900px) {
      width: 100%;
      order: 1;
      padding: 25px 20px 42px 20px;
    }

    @media (max-width: 600px) {
      padding: 25px 16px 42px 16px;
    }
  }

  &.resources {
    width: 27%;

    @media (max-width: 900px) {
      width: 100%;
      order: 2;
      padding: 25px 20px 42px 20px;
    }

    @media (max-width: 600px) {
      padding: 25px 16px 42px 16px;
    }
  }

  @media (max-width: 900px) {
    padding: 25px 20px 42px 20px;
  }

  @media (max-width: 600px) {
    padding: 25px 16px 42px 16px;
  }
`
export const YourTasksTitle = styled.div`
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 24px;

  @media (max-width: 600px) {
    font-size: 16px;
    margin-bottom: 16px;
  }
`

export const ContentContainer = styled.div`
  display: flex;
  gap: 2%;
  background-color: #e5e5e5;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 0;
  }
`

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 70vh;
`
